export const GET_SPOT_RATE = 'GET_SPOT_RATE';
export const GET_SPOT_RATE_SUCCESS = 'GET_SPOT_RATE_SUCCESS';
export const GET_SPOT_RATE_ERROR = 'GET_SPOT_RATE_ERROR';
export const CLEAR_SPOT_RATE = 'CLEAR_SPOT_RATE';
export const GET_CROSS_BORDER_QUOTE = 'GET_CROSS_BORDER_QUOTE';
export const GET_CROSS_BORDER_QUOTE_SUCCESS = 'GET_CROSS_BORDER_QUOTE_SUCCESS';
export const GET_CROSS_BORDER_QUOTE_ERROR = 'GET_CROSS_BORDER_QUOTE_ERROR';
export const CLEAR_CROSS_BORDER_QUOTE = 'CLEAR_CROSS_BORDER_QUOTE';
export const EXECUTE_CROSS_BORDER_QUOTE = 'EXECUTE_CROSS_BORDER_QUOTE';
export const EXECUTE_CROSS_BORDER_QUOTE_SUCCESS = 'EXECUTE_CROSS_BORDER_QUOTE_SUCCESS';
export const EXECUTE_CROSS_BORDER_QUOTE_ERROR = 'EXECUTE_CROSS_BORDER_QUOTE_ERROR';
export const TRACK_CROSS_BORDER_QUOTE = 'TRACK_CROSS_BORDER_QUOTE';

export const getSpotRate = (payload) => ({
  type: GET_SPOT_RATE,
  payload,
});

export const clearSpotRate = () => ({
  type: CLEAR_SPOT_RATE,
});

export const getCrossBorderQuote = (payload) => ({
  type: GET_CROSS_BORDER_QUOTE,
  payload,
});

export const executeCrossBorderQuote = (payload) => ({
  type: EXECUTE_CROSS_BORDER_QUOTE,
  payload,
});

export const clearCrossBorderQuote = () => ({
  type: CLEAR_CROSS_BORDER_QUOTE,
});

export const trackCrossBorderQuote = (payload) => ({
  type: TRACK_CROSS_BORDER_QUOTE,
  payload,
});
